import * as types from './actionTypes'
import * as api from '../../../common/api'
import { getCustomerID } from './selectors';

export const fetchCustomer = id => ({
    types: [types.FETCH_PROFILE_REQUEST, types.FETCH_PROFILE_SUCCESS, types.FETCH_PROFILE_FAILURE],
    apiCall: () => api.findCustomerById(id)
});

export const fetchOTTStatus = id =>
 ({
    types: [types.FETCH_OTTSTATUS_REQUEST, types.FETCH_OTTSTATUS_SUCCESS, types.FETCH_OTTSTATUS_FAILURE],
    apiCall: () => api.getCustomerOTTStatus(id)
});

export const sendSMS = (customerId, phoneNumber, smsContent) =>
 ({
    types: [types.SEND_SMS_REQUEST, types.SEND_SMS_SUCCESS, types.SEND_SMS_FAILURE],
    apiCall: () => api.sendSMS(customerId, phoneNumber, smsContent)
});

export const updateCustomer = (customerId, updateFormData) =>
 ({
    types: [types.UPDATE_CUSTOMER_REQUEST, types.UPDATE_CUSTOMER_SUCCESS, types.UPDATE_CUSTOMER_FAILURE],
    apiCall: () => api.updateCustomer(customerId, updateFormData)
});

export const toggleButton = (enabled) => ({
    type: types.TOGGLE_SMS_BUTTON,
    buttonEnabled: enabled
});

export const setCustomerProperty = (propertyName, propertyValue) => ({
    type: types.UPDATE_FORM_SET_PROPERTY,
    propertyName,
    propertyValue
});

export const clearUpdateForm = () => ({
    type: types.UPDATE_FORM_CLEAR,
});

export const saveStart = () => ({
    type: types.SAVE_START,
});
export const saveStop = () => ({
    type: types.SAVE_STOP,
});